import { Model } from "@vuex-orm/core";
import User from "@/models/user";

export default class SiteGroup extends Model {
  static entity = "site_groups";

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      users: this.hasMany(User, "site_group_id"),
    };
  }
}
